import { render, staticRenderFns } from "./examSingUpPriveEdit.vue?vue&type=template&id=08ebb305"
import script from "./examSingUpPriveEdit.vue?vue&type=script&lang=js"
export * from "./examSingUpPriveEdit.vue?vue&type=script&lang=js"
import style0 from "./examSingUpPriveEdit.vue?vue&type=style&index=0&id=08ebb305&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports